<template>
    <button :disabled="disabled || isLoading" class="flex items-center gap-1.5">
        <fa v-if="!isLoading" :icon="['fal', 'paper-plane']"></fa>
        <div class="flex items-center justify-center gap-2">
            <div v-if="isLoading" class="flex flex-row gap-1">
                <div class="bg-blue-100 w-1 h-1 rounded-full animate-bounce [animation-delay:.7s]"></div>
                <div class="bg-blue-100 w-1 h-1 rounded-full animate-bounce [animation-delay:.3s]"></div>
                <div class="bg-blue-100 w-1 h-1 rounded-full animate-bounce [animation-delay:.7s]"></div>
            </div>
            <span>{{ isLoading ? (label.endsWith('e') ? label.slice(0, -1) + 'ing' : label + 'ing') : label }}</span>
        </div>
    </button>
</template>
<script setup>
const props = defineProps({
    disabled: {
        type: Boolean,
        default: false,
    },
    isLoading: {
        type: Boolean,
        default: false,
    },
    label: {
        type: String,
        default: "Send",
    },
});
</script>
<style scoped>
button {
    @apply bg-blue-500 text-white;
    display: flex;
    height: 32px;
    padding: 0px 12px;
    align-items: center;
    /* H2 */
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    border-radius: 4px;
}
button svg {
    @apply text-white mr-1;
    font-family: "Font Awesome 6 Pro";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}
</style>
